export default __webpack_public_path__ + "static/media/la-republica.34c82fd3.svg";